<template>
  <div>
    <div class='row'>
      <div class='col'>
        <div class="row">
          <div class="col">
            <div id="data-alert" v-if='imageSoonDownloadable' class="alert alert-info span-width alert-dismissible"
                 role="alert">
              <strong>Some data is pending!</strong> It will show up in the table shortly.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="table-caption mb-1">Session Images</div>
          </div>
          <div class="col-auto">
            <a :href="archiveLink" target="_blank">LCO Science Archive (this session's images)</a>
          </div>
        </div>
        <!-- FIXME: Don't scroll heading -->
        <div style="height: 300px; overflow: auto;">
          <table class='table table-hover table-condensed' id='session-table'>
            <thead>
            <tr>
              <th>Target Name</th>
              <th>Right Ascension</th>
              <th>Declination</th>
              <th>Exposure Time (sec)</th>
              <th>Filter</th>
              <th>Timestamp (UTC)</th>
              <th>Image type</th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="image in sessionImages">
              <td>{{ image.targetName }}</td>
              <td>{{ image.ra }}</td>
              <td>{{ image.dec }}</td>
              <td>{{ image.exposureTime }}</td>
              <td>{{ image.filterType }}</td>
              <td>{{ image.timestamp }}</td>
              <td>{{ image.imageType }}</td>
              <td><a :href="image.downloadUrl" data-toggle="tooltip" title="Download FITS file"><img
                  src="../img/ic_file_download_black_24px.svg"/></a></td>
              <td><a @click="getLargeImage(image.id)" style="cursor: hand" data-toggle="tooltip"
                     title="Preview image in new tab"><img src="../img/ic_image_24px.svg"/></a></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery';
  import moment from 'moment';

  import 'rti.css';
  import { decimalRaToSexagesimal, decimalDecToSexagesimal, progressStates } from '../js/common';

  export default {
    name: 'sessionTable',
    props: ['telescope', 'session', 'status', 'archiveLink', 'propId'],

    data: function() {
      return {
        archiveFramesUrl: 'https://archive-api.lco.global/frames/',
        queryStartString: this.formatDateForQuery(this.session.activeSessionStart),
        queryEndString: this.formatDateForQuery(this.session.activeSessionEnd),
        archivePollingSeconds: 10,
        imageSoonDownloadable: false,
        lastProgressStatus: '',
        latestFrameId: null,
        thumbnail: '',
        sessionImages: []
      };
    },
    mounted: function() {
      sessionStorage.thumbnail = '';

      this.queryArchive();
      this.updateThumbnail();

      this.queryArchiveTimer = setInterval(
        this.queryArchive, 1000 * this.archivePollingSeconds
      );

      this.thumbnailTimer = setInterval(
        this.updateThumbnail, 1000
      );
    },
    beforeDestroy: function() {
      clearInterval(this.queryArchiveTimer);
      clearInterval(this.thumbnailTimer);
    },
    methods: {
      updateThumbnail: function() {
        this.thumbnail = sessionStorage.thumbnail;
      },
      queryArchive: function() {
        let that = this;

        $.ajax({
          url: this.archiveFramesUrl,
          data: {

            'PROPID': this.propId,
            'SITEID': this.telescope.site,
            'TELID': this.telescope.telescope,
            'start': this.queryStartString,
            'end': this.queryEndString,
            'ordering': 'DATE_OBS'

          },
          dataType: 'json',
          success: function(dataArchive) {
            let dataArchiveResults = dataArchive['results'];

            if (dataArchiveResults.length === 0 || dataArchiveResults.length === that.sessionImages.length)
              return;

            let formattedResults = [];

            for (let result of dataArchiveResults) {
              let formattedResult = {};
              let targetCoordinates = that.computeCoordsFromGeoJson(result.area.coordinates[0]);

              formattedResult.targetName = result.OBJECT;
              formattedResult.ra = decimalRaToSexagesimal(targetCoordinates.ra);
              formattedResult.dec = decimalDecToSexagesimal(targetCoordinates.dec);
              formattedResult.exposureTime = that.formatExposureTime(result.EXPTIME);
              formattedResult.filterType = that.formatFilterType(result.FILTER);
              formattedResult.timestamp = that.formatImageTimestamp(result.DATE_OBS);
              formattedResult.imageType = that.getImageType(result.RLEVEL);
              formattedResult.id = result.id;
              formattedResult.downloadUrl = result.url;

              formattedResults.unshift(formattedResult);
            }
            that.imageSoonDownloadable = false;
            that.sessionImages = formattedResults;
          }
        });
      },
      getLargeImage: function(id) {
        $.getJSON(this.largeImageURL(id), (data) => {
          window.open(data['url'], '_blank');
        });
      },
      largeImageURL: function(id) {
        return 'https://thumbnails.lco.global/' + id + '/?width=4000&height=4000';
      },
      getImageType: function(rlevel) {
        return rlevel === 0 ? 'Preview' : 'Processed';
      },
      formatFilterType: function(filter) {
        if (filter === 'rp')
          return 'Green (rp)';
        else if (filter === 'ip')
          return 'Red (ip)';
        else if (filter === 'gp')
          return 'Blue (gp)';
        else
          return 'Unknown';
      },
      formatExposureTime: function(exposureTime) {
        /*
          Round because 0m4 FITSHeaders have EXPTIME and REQTIME, of which the EXPTIME is slightly off of the value the
          user requested.
        */
        return Math.round(exposureTime);
      },
      formatImageTimestamp: function(timestamp) {
        return moment(timestamp).utc().format('YYYY-MM-DD HH:mm:ss');
      },
      computeCoordsFromGeoJson: function(coordinates) {
        let ras = [];
        let decs = [];

        for (let i = 0; i < coordinates.length - 1; i++) {
          ras.push(coordinates[i][0]);
          decs.push(coordinates[i][1]);
        }

        let ra = ras.reduce((sum, ra) => ra + sum, 0) / ras.length;

        if (ra < 0) {
          ra += 360;
        } else if (ra >= 360) {
          ra -= 360;
        }

        return {
          'ra': ra,
          'dec': decs.reduce((sum, dec) => dec + sum, 0) / decs.length
        };
      },
      formatDateForQuery: function(seconds) {
        return moment(seconds * 1000).utcOffset(0).format('YYYY-MM-DD HH:mm:ss');
      }
    },
    watch: {
      status: function() {
        if (this.status.progress === progressStates.READY && this.lastProgressStatus === progressStates.EXECUTING) {
          this.imageSoonDownloadable = true;
        }
        this.lastProgressStatus = this.status.progress;
      }
    }
  };

  // Enable all tooltips in the document.
  $(document).ready(function() {
    $('[data-toggle="tooltip"]').tooltip({
      container: 'body'
    });
  });
</script>
